// import { useEffect, useState } from "react";
// import FormField from "./FormField";
// import apiCall from "../helper/apiCall";

// // Form for the General Information step.
// const ProductUploadGeneralForm = ({ formData, onNext, onBack }) => {
//   const [localData, setLocalData] = useState(formData);
//   const [errors, setErrors] = useState({});
//   const [sellers, setSellers] = useState([]);
//   const [manufacturers, setManufacturers] = useState([]);
//   const [poItemRefNumbers, setPoItemRefNumbers] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [inventories, setInventories] = useState([]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     if(name === 'seller_id'){
//       setLocalData((prevData) => ({
//         ...prevData,
//         [name]: value,
//         inventory_id: '', // Reset inventory when seller changes
//       }));
//     } else {
//       setLocalData((prevData) => ({
//         ...prevData,
//         [name]: value,
//       }));
//     }
    
//     // Clear the error for the field being edited
//     if (errors[name]) {
//       setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
//     }
//   };

//   const validate = () => {
//     const newErrors = {};
//     if (!localData.seller_id) newErrors.seller_id = 'Please select seller.';
//     if (!localData.inventory_id) newErrors.inventory_id = 'Please select inventory.';
//     if (!localData.category_id) newErrors.category_id = 'Please select category.';
//     if (!localData.product_name) newErrors.product_name = 'Product name is required.';
//     if (!localData.product_description) newErrors.product_description = 'Product description is required.';
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleNextClick = () => {
//     if (validate()) {
//       onNext(localData);
//     }
//   };

//   const handleBlur = (e) => {
//     const { name, value } = e.target;
//     if (!value) {
//       setErrors((prevErrors) => ({ ...prevErrors, [name]: `${e.target.labels[0].textContent.replace(' *', '')} is required.` }));
//     } else {
//       setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
//     }
//   };

//   const fetchSellers = async () => {
//     try {
//       const result = await apiCall('getSellers');
//       setSellers(result.data);
//     } catch (error) {
//       console.error("Failed to fetch getSellers:", error);
//     }
//   };

//   const fetchManufacturers = async () => {
//     try {
//       const result = await apiCall('getManufacturerNames');
//       setManufacturers(result.data);
//     } catch (error) {
//       console.error("Failed to fetch getManufacturerNames:", error);
//     }
//   };

//   const fetchCategories = async () => {
//     try {
//       const result = await apiCall('getCategories');
//       setCategories(result.data);
//     } catch (error) {
//       console.error("Failed to fetch getCategories:", error);
//     }
//   };

//   const fetchInventories = async (sellerId) => {
//     if (!sellerId) {
//       setInventories([]);
//       return;
//     }
//     try {
//       const result = await apiCall('getInventories');
//       const filteredData = result.data.filter(inventory => inventory.seller_id === sellerId);
//       setInventories(filteredData);
//     } catch (error) {
//       console.error("Failed to fetch getInventories:", error);
//     }
//   };

//   const fetchPORefNubers = async (manufacturer_id) => {
//     if (!manufacturer_id) {
//       setPoItemRefNumbers([]);
//       return;
//     }
//     try {
//       const result = await apiCall('getPurchaseOrderByManufactutrerId');
//       setPoItemRefNumbers(result.data);
//     } catch (error) {
//       console.error("Failed to fetch getPurchaseOrderByManufactutrerId:", error);
//     }
//   };

//   useEffect(() => {
//       fetchSellers();
//       fetchCategories();
//       fetchManufacturers();
//     }, []);

//   // New useEffect to fetch inventories whenever seller_id changes
//   useEffect(() => {
//       if (localData.seller_id) {
//         fetchInventories(localData.seller_id);
//       }
//     }, [localData.seller_id]);

//     useEffect(() => {
//       if (localData.manufacturer_id) {
//         fetchInventories(localData.manufacturer_id);
//       }
//     }, [localData.manufacturer_id]);

//   return (
//     <div className="mx-auto flex flex-col space-y-4">
//       <h2 className="text-lg font-semibold mb-4">General Information</h2>
//       <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//         <FormField
//           label="Select Seller"
//           id="seller_id"
//           type="select"
//           value={localData.seller_id || ''}
//           onChange={handleChange}
//           onBlur={handleBlur}
//           required={true}
//           errorMessage={errors.seller_id}
//         >
//           <option value="">Select seller</option>
//             {sellers.map((el) => (
//               <option key={el.id} value={el.id}>
//                 {el.full_name}
//               </option>
//             ))}
//         </FormField>
//         <FormField
//           label="Select inventory"
//           id="inventory_id"
//           type="select"
//           value={localData.inventory_id || ''}
//           onChange={handleChange}
//           onBlur={handleBlur}
//           required={true}
//           errorMessage={errors.inventory_id}
//         >
//           <option value="">Select inventory</option>
//             {inventories.map((el) => (
//               <option key={el.inventory_id} value={el.inventory_id}>
//                 {el.inventory_name}
//               </option>
//             ))}
//         </FormField>
//         <FormField
//           label="Select manufacture"
//           id="manufacturer_id"
//           type="select"
//           value={localData.manufacturer_id || ''}
//           onChange={handleChange}
//           onBlur={handleBlur}
//           required={true}
//           errorMessage={errors.manufacturer_id}
//         >
//           <option value="">Select manufacturer</option>
//             {manufacturers.map((el) => (
//               <option key={el.manufacturer_id} value={el.manufacturer_id}>
//                 {el.manufacturer_name}
//               </option>
//             ))}
//         </FormField>
//         <FormField
//           label="Select PO reference number"
//           id="po_item_reference"
//           type="select"
//           value={localData.po_item_reference || ''}
//           onChange={handleChange}
//           onBlur={handleBlur}
//           required={true}
//           errorMessage={errors.po_item_reference}
//         >
//           <option value="">Select PO reference number</option>
//             {manufacturers.map((el) => (
//               <option key={el.po_item_reference} value={el.po_item_reference}>
//                 {el.po_item_reference}
//               </option>
//             ))}
//         </FormField>
//         <FormField
//           label="Select Category"
//           id="category_id"
//           type="select"
//           value={localData.category_id || ''}
//           onChange={handleChange}
//           onBlur={handleBlur}
//           required={true}
//           errorMessage={errors.category_id}
//         >
//           <option value="">Select category</option>
//             {categories.map((el) => (
//               <option key={el.category_id} value={el.category_id}>
//                 {el.category_name}
//               </option>
//             ))}
//         </FormField>
//         <FormField
//           label="Product Name"
//           id="product_name"
//           type="text"
//           value={localData.product_name || ''}
//           onChange={handleChange}
//           onBlur={handleBlur}
//           required={true}
//           errorMessage={errors.product_name}
//         />
//       </div>
//       <div className="space-y-2">
//         <label htmlFor="product_description" className="block text-sm font-medium text-gray-700">Description<span className="text-red-500"> *</span></label>
//         <textarea
//           id="product_description"
//           name="product_description"
//           value={localData.product_description || ''}
//           onChange={handleChange}
//           onBlur={handleBlur}
//           rows="4"
//           required={true}
//           className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//         />
//         {errors.product_description && <p className="text-red-500 text-sm mt-2">{errors.product_description}</p>}
//       </div>
//       <div className="flex justify-end pt-4">
//         <button
//           onClick={handleNextClick}
//           className="px-6 py-2 bg-blue-600 text-white font-medium rounded-lg shadow hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
//         >
//           Next
//         </button>
//       </div>
//     </div>
//   );
// };

// export default ProductUploadGeneralForm;


import { useEffect, useState } from "react";
import FormField from "./FormField"; // Assuming this is for standard inputs/selects
import SearchableDropdown from "./SearchableDropdown"; // NEW: Import the searchable dropdown
import apiCall from "../helper/apiCall";

// Form for the General Information step.
const ProductUploadGeneralForm = ({ formData, onNext, onBack }) => {
  const [localData, setLocalData] = useState(formData);
  const [errors, setErrors] = useState({});
  const [sellers, setSellers] = useState([]);
  const [manufacturers, setManufacturers] = useState([]);
  const [poItemRefNumbers, setPoItemRefNumbers] = useState([]);
  const [categories, setCategories] = useState([]);
  const [inventories, setInventories] = useState([]);
  const [parentCategories, setParentCategories] = useState([]);
  const [childCategories, setChildCategories] = useState([]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    // Special handling for seller_id to reset inventory_id
    if (name === 'seller_id') {
      setLocalData((prevData) => ({
        ...prevData,
        [name]: value,
        inventory_id: '', // Reset inventory when seller changes
      }));
    } else {
      setLocalData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }

    // Clear the error for the field being edited
    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!localData.seller_id) newErrors.seller_id = 'Please select seller.';
    if (!localData.inventory_id) newErrors.inventory_id = 'Please select inventory.';
    if (!localData.manufacturer_id) newErrors.manufacturer_id = 'Please select manufacturer.'; // Added validation for manufacturer
    if (!localData.purchase_order_item_id) newErrors.purchase_order_item_id = 'Please select PO reference number.'; // Added validation for PO Ref
    if (!localData.category_id) newErrors.category_id = 'Please select category.';
    if (!localData.product_name) newErrors.product_name = 'Product name is required.';
    if (!localData.product_description) newErrors.product_description = 'Product description is required.';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNextClick = () => {
    if (validate()) {
      onNext(localData);
    }
  };

  // Generic onBlur handler
  const handleBlur = (e) => {
    const { name, value, labels } = e.target;
    const labelText = labels?.[0]?.textContent.replace(' *', '') || name;
    if (!value) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: `${labelText} is required.` }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    }
  };

  // --- API Calls ---

  const fetchSellers = async () => {
    try {
      const result = await apiCall('getSellers');
      setSellers(result.data || []);
    } catch (error) {
      console.error("Failed to fetch getSellers:", error);
    }
  };

  const fetchManufacturers = async () => {
    try {
      const result = await apiCall('getManufacturerNames');
      setManufacturers(result.data || []);
    } catch (error) {
      console.error("Failed to fetch getManufacturerNames:", error);
    }
  };

  const fetchCategories = async () => {
    try {
      const result = await apiCall('getCategories');
      setCategories(result.data || []);
    } catch (error) {
      console.error("Failed to fetch getCategories:", error);
    }
  };

  const fetchParenCategories = async () => {
    try {
      const result = await apiCall('getParentCategories');
      setParentCategories(result.data || []);
    } catch (error) {
      console.error("Failed to fetch getParentCategories:", error);
    }
  };

  const fetchInventories = async (sellerId) => {
    setInventories([]); // Clear previous inventory
    if (!sellerId) return;
    try {
      const result = await apiCall('getInventories');
      // NOTE: You might need to adjust this filter based on your actual API data structure
      const filteredData = result.data.filter(inventory => String(inventory.seller_id) === String(sellerId));
      setInventories(filteredData || []);
    } catch (error) {
      console.error("Failed to fetch getInventories:", error);
    }
  };

  const fetchPORefNubers = async (manufacturer_id) => {
    setPoItemRefNumbers([]); // Clear previous PO Ref Numbers
    if (!manufacturer_id) return;
    try {
      // Assuming your API call is correct and returns an array of PO reference objects/strings
      const result = await apiCall('getPurchaseOrderByManufactutrerId', { manufacturer_id }); // Added manufacturer_id to API call (if needed)
      setPoItemRefNumbers(result.data || []);
    } catch (error) {
      console.error("Failed to fetch getPurchaseOrderByManufactutrerId:", error);
    }
  };

  const fetchMainCategories = async (parent_category_id) => {
    setCategories([]); 
    if (!parent_category_id) return;
    try {
      const result = await apiCall('getMainCategories', { parent_category_id }); // Added manufacturer_id to API call (if needed)
      setCategories(result.data || []);
    } catch (error) {
      console.error("Failed to fetch fetchMainCategories:", error);
    }
  };

  const fetchChildCategories = async (category_id) => {
    setChildCategories([]); 
    if (!category_id) return;
    try {
      const result = await apiCall('getChildCategories', { category_id }); // Added manufacturer_id to API call (if needed)
      setChildCategories(result.data || []);
    } catch (error) {
      console.error("Failed to fetch getChildCategories:", error);
    }
  };

  // --- useEffects for Data Fetching ---

  // Initial data fetch
  useEffect(() => {
    fetchSellers();
    //fetchCategories();
    fetchManufacturers();
    fetchParenCategories();
  }, []);

  // Fetch inventories whenever seller_id changes
  useEffect(() => {
    if (localData.seller_id) {
      fetchInventories(localData.seller_id);
    }
  }, [localData.seller_id]);


  

  

  useEffect(() => {
    // Corrected dependency array (was calling fetchInventories instead of fetchPORefNubers)
    if (localData.parent_category_id) {
      fetchMainCategories(localData.parent_category_id);
    } else {
        setLocalData(prevData => ({ ...prevData, category_id: '' })); // Clear PO Ref when manufacturer changes
    }
  }, [localData.parent_category_id]);

  useEffect(() => {
    if (localData.category_id) {
      fetchChildCategories(localData.category_id);
    } else {
        setLocalData(prevData => ({ ...prevData, child_category_id: '' })); // Clear PO Ref when manufacturer changes
    }
  }, [localData.category_id]);

  // Fetch PO reference numbers whenever manufacturer_id changes
  useEffect(() => {
    // Corrected dependency array (was calling fetchInventories instead of fetchPORefNubers)
    if (localData.manufacturer_id) {
      fetchPORefNubers(localData.manufacturer_id);
    } else {
        setLocalData(prevData => ({ ...prevData, purchase_order_item_id: '' })); // Clear PO Ref when manufacturer changes
    }
  }, [localData.manufacturer_id]);


  // Prepare data for SearchableDropdown
  const poOptions = poItemRefNumbers.map(item => ({
      value: item.purchase_order_item_id,
      label: item.po_item_reference,
  }));


  return (
    <div className="mx-auto flex flex-col space-y-4">
      <h2 className="text-lg font-semibold mb-4">General Information</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Select Seller (Standard Dropdown) */}
        <FormField
          label="Select Seller"
          id="seller_id"
          type="select"
          value={localData.seller_id || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          required={true}
          errorMessage={errors.seller_id}
        >
          <option value="">Select seller</option>
            {sellers.map((el) => (
              <option key={el.id} value={el.id}>
                {el.full_name}
              </option>
            ))}
        </FormField>
        
        {/* Select inventory (Standard Dropdown) */}
        <FormField
          label="Select inventory"
          id="inventory_id"
          type="select"
          value={localData.inventory_id || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          required={true}
          errorMessage={errors.inventory_id}
        >
          <option value="">Select inventory</option>
            {inventories.map((el) => (
              <option key={el.inventory_id} value={el.inventory_id}>
                {el.inventory_name}
              </option>
            ))}
        </FormField>
        
        {/* Select manufacture (Standard Dropdown) */}
        <FormField
          label="Select manufacturer"
          id="manufacturer_id"
          type="select"
          value={localData.manufacturer_id || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          required={true}
          errorMessage={errors.manufacturer_id}
        >
          <option value="">Select manufacturer</option>
            {manufacturers.map((el) => (
              <option key={el.manufacturer_id} value={el.manufacturer_id}>
                {el.manufacturer_name}
              </option>
            ))}
        </FormField>

        {/* Select PO reference number (Searchable Dropdown) */}
        {/* NOTE: We replaced FormField with SearchableDropdown */}
        <SearchableDropdown
          label="Select PO reference number"
          id="purchase_order_item_id"
          value={localData.purchase_order_item_id || ''}
          onChange={handleChange}
          onBlur={handleBlur} // The SearchableDropdown will propagate the blur event
          required={true}
          errorMessage={errors.purchase_order_item_id}
          options={poOptions} // Use the prepared PO options array
        />


         {/* Select Category (Standard Dropdown) */}
        <FormField
          label="Select Parent Category"
          id="parent_category_id"
          type="select"
          value={localData.parent_category_id || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          required={true}
          errorMessage={errors.parent_category_id}
        >
          <option value="">Select parent category</option>
            {parentCategories.map((el) => (
              <option key={el.category_id} value={el.category_id}>
                {el.category_name}
              </option>
            ))}
        </FormField>
        {/* Select Category (Standard Dropdown) */}
        <FormField
          label="Select Category"
          id="category_id"
          type="select"
          value={localData.category_id || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          required={true}
          errorMessage={errors.category_id}
        >
          <option value="">Select category</option>
            {categories.map((el) => (
              <option key={el.category_id} value={el.category_id}>
                {el.category_name}
              </option>
            ))}
        </FormField>

        {/* Select Category (Standard Dropdown) */}
        <FormField
          label="Select child category"
          id="child_category_id"
          type="select"
          value={localData.child_category_id || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          
          errorMessage={errors.child_category_id}
        >
          <option value="">Select child category</option>
            {childCategories.map((el) => (
              <option key={el.category_id} value={el.category_id}>
                {el.category_name}
              </option>
            ))}
        </FormField>
        
        {/* Product Name (Standard Text Input) */}
        <FormField
          label="Product Name"
          id="product_name"
          type="text"
          value={localData.product_name || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          required={true}
          errorMessage={errors.product_name}
        />
      </div>
      
      {/* Product Description (Textarea) */}
      <div className="space-y-2">
        <label htmlFor="product_description" className="block text-sm font-medium text-gray-700">Description<span className="text-red-500"> *</span></label>
        <textarea
          id="product_description"
          name="product_description"
          value={localData.product_description || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          rows="4"
          required={true}
          className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        {errors.product_description && <p className="text-red-500 text-sm mt-2">{errors.product_description}</p>}
      </div>
      
      {/* Navigation Buttons */}
      <div className="flex justify-end pt-4">
        <button
          onClick={handleNextClick}
          className="px-6 py-2 bg-blue-600 text-white font-medium rounded-lg shadow hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default ProductUploadGeneralForm;